export default {
      id: "ic-nav-chevron-right-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-nav-chevron-right-usage",
      toString: function () {
        return this.url;
      }
    }